import React from "react";
import styles from "./EditorButtonBar.module.scss";
import pythonIcon from "./1024-px-python-logo-notext-svg@3x.png";
import { makeCodeSvgColor } from "../MakecodeSVG/MakecodeSVG";
import classroomIcon from "./170-px-microbit-green-svg.png";
import AnchorButton from "../AnchorButton/AnchorButton";

const EditorButton = ({
  imgSrc,
  buttonText,
  href
}: {
  imgSrc: string;
  buttonText: string;
  href: string;
}) => (
  <div>
    <img height={50} width={50} src={imgSrc} alt="" />
    <AnchorButton to={href}>
      <img height={20} width={20} src={imgSrc} alt="" />
      <span>{buttonText}</span>
    </AnchorButton>
  </div>
);

const EditorButtonBar = () => (
  <div className={styles.root}>
    <EditorButton
      imgSrc={makeCodeSvgColor}
      buttonText="Microsoft MakeCode"
      href="https://makecode.microbit.org"
    />
    <EditorButton
      imgSrc={pythonIcon}
      buttonText="Python"
      href="https://python.microbit.org"
    />
    <EditorButton
      imgSrc={classroomIcon}
      buttonText="Classroom"
      href="https://classroom.microbit.org/"
    />
  </div>
);

export default EditorButtonBar;
